// extracted by mini-css-extract-plugin
export default {"LoginContainer":"Auth_LoginContainer__zMZSg","FormBox":"Auth_FormBox__D7FB9","FormControl":"Auth_FormControl__3RefK"};